// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1O1_x","modal":"styles-module__modal___3kyqp","reo":"styles-module__reo___2pnuK","type":"styles-module__type___Z_Hy3"};